import React from 'react';
import { CardFooter as KendoCardFooter } from '@progress/kendo-react-layout';

/**
 * CardFooter component wrapping KendoReact CardFooter with all supported props.
 * 
 * @param {object} props
 * @param {React.ReactNode} [props.children] - CardFooter children elements.
 * @param {string} [props.className] - Additional classes for the CardFooter.
 * @param {React.CSSProperties} [props.style] - Additional CSS styles.
 * * @returns {JSX.Element}
 */
export const CardFooter = ({ 
    className = '', 
    style = {}, 
    children
}) => (
  <KendoCardFooter 
    className={className} 
    style={style} 
  >
    {children}
  </KendoCardFooter>
);